import { Helmet } from 'react-helmet';

const HelmetMetaInformation = ({ title, description, links = [] }) => {
  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      {links.map((link, index) => (
        <link
          key={index}
          rel="alternate"
          // eslint-disable-next-line react/no-unknown-property
          hreflang={link.hreflang}
          href={link.href}
        />
      ))}
    </Helmet>
  );
};

export default HelmetMetaInformation;
